import React from "react";
import { Card, CardBody, Col } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { VariationOfSwitche } from "../../../../Constant";
import { VARIATION_SWITCH } from "../../../../Data/FormWidgets";
import { UL } from "../../../../AbstractElements";
import { VariationOfSwitcheOne } from "./VariationOfSwitcheOne";
import { VariationOfSwitcheTwo } from "./VariationOfSwitcheTwo";

const VariationOfSwitches = () => {
  return (
    <Col md="6">
      <Card>
        <CommonCardHeader title={VariationOfSwitche} span={VARIATION_SWITCH} />
        <CardBody className="common-flex">
          <UL className="tg-list common-flex simple-list d-flex flex-row">
            <VariationOfSwitcheOne />
            <VariationOfSwitcheTwo />
          </UL>
        </CardBody>
      </Card>
    </Col>
  );
};

export default VariationOfSwitches;
